import { Controller } from "@hotwired/stimulus";

const drawerOptions = {
  placement: "right",
  backdrop: false,
  bodyScrolling: false,
  edge: false,
  onHide: () => {},
  onShow: () => {},
  onToggle: () => {},
};

const drawerInstanceOptions = {
  id: "education-hub-education_drawer",
  override: true,
};

export default class extends Controller {
  static targets = ["education_drawer"];

  educationHubDrawer;
  educationHubTab;
  isInitialized = false;

  connect() {
    const drawerElement = document.getElementById("education-hub-education_drawer");
    if (!drawerElement) {
      return;
    }
    this.educationHubDrawer = new Drawer(
      drawerElement,
      drawerOptions,
      drawerInstanceOptions
    );
    this.educationHubDrawer.hide();

    const tabElement = document.getElementById("education-hub-tab");
    if (window.Tabs && tabElement) {
      if (!tabElement.hasAttribute("data-flowbite-initialized")) {
        this.educationHubTab = new Tabs(tabElement, [], {}, {});
        tabElement.setAttribute("data-flowbite-initialized", "true");
      } else {
        this.educationHubTab = window.Tabs.getInstance
          ? window.Tabs.getInstance(tabElement)
          : null;
      }
    }

    if (!this.isInitialized) {
      this.initializeFormState();
      this.isInitialized = true;
    }

    window.addEventListener('popstate', () => {
      setTimeout(() => {
        this.initializeFormState();
      }, 100);
    });

    document.addEventListener('turbo:load', () => {
      this.initializeFormState();
    });
  }

  initializeFormState() {
    const drawerElement = document.getElementById('education-hub-education_drawer');
    if (!drawerElement) return;

    const event = new CustomEvent('initialize-form-state', {
      detail: { urlParams: new URLSearchParams(window.location.search) }
    });
    drawerElement.dispatchEvent(event);
  }

  openDrawer(event) {
    this.educationHubDrawer.show();
    if (event) {
      const button = event.target.closest("button");
      if (button && button.id === "custom-lightbulb-span") {
        this.educationHubTab?.show("help");
        return;
      }
    }
    this.educationHubTab?.show("filter");

    setTimeout(() => {
      this.initializeFormState();
    }, 100);
  }

  closeEducationDrawer() {
    this.educationHubDrawer.hide();
  }

  handleCustomFilterByTag(event) {
    const filterValue = event.target.dataset.filterValue;
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;

    if(params.getAll('category').includes(filterValue)) return;

    params.delete('category');
    params.append('category', filterValue);
    window.location.href = currentUrl.toString();
  }
} 